import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { ProductBrodCramp, NextImage } from "components";
import { getImageUrl } from "utils/helperFunction";

export default function ProductGallery({ name, matches, images }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const [data, setData] = useState([]);

  useEffect(() => {
    setData(
      images.map(item => ({
        url: getImageUrl(item.attributes.formats, "medium")?.url,
        alt: item.attributes.caption,
      })),
    );
  }, [images]);

  return (
    <>
      {!matches && <ProductBrodCramp name={name} />}
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
        }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{
          swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
        }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="view-selected-image-swiper "
      >
        {data.map(img => (
          <SwiperSlide key={img.alt}>
            <NextImage
              src={img.url}
              alt={img.alt}
              layout={"fill"}
              placeholder="blur"
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="swiper-thumbnails-row"
      >
        {data.map(img => (
          <SwiperSlide key={img.alt}>
            <NextImage
              src={img.url}
              alt={img.alt}
              layout={"fill"}
              placeholder="blur"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
